module.exports = __webpack_public_path__ + "img/seloMedalhaDiamanteSombra.1653d2cc.png";